import Swal from "sweetalert2";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

import router from '../../router/index'

export const apiRequestsHelper = {
    handleResponseWithDialogs(response, showSuccessDialog) {
        console.log(response)
        var responseMessage = response.data.message;
        if (response.data && !responseMessage || responseMessage === "") {
            var dataParsed = JSON.parse(response.data?.text | "Brak danych");
            if (dataParsed) {
                responseMessage = dataParsed.message;
            }
        }
        const lazyloaderManagerModule = useLazyLoaderModule();
        if (response.status === 200) {

            if (showSuccessDialog) {
                return Swal.fire({
                    title: "Zrobione!",
                    text: responseMessage,
                    icon: "success",
                    customClass: {
                        container: "swal-highest"
                    },

                }).then(() => {

                    console.log("handleResponseWithDialogs setting loader to false");
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setProgressBarMessage("");
                })
            } else {
                lazyloaderManagerModule.setDisplayLazyLoader(false);
                lazyloaderManagerModule.setProgressBarMessage("");
            }

        } else if (response.status === 203) {
            console.log("Staus 203:", response);
            return apiRequestsHelper.fireExceptionModal("Coś jest nie tak!", responseMessage, "warning", response)
                .then(() => {
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setProgressBarMessage("");
                    console.log("Returning 203 response: ", response);
                    return new Promise((resolve) => {
                        resolve(response);
                    });
                })


        } else if (response.status === 204) {
            console.log(response);
            return Swal.fire({
                title: "Błąd!",
                text: "Brak danych, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            }).then(() => {
                lazyloaderManagerModule.setDisplayLazyLoader(false);
                lazyloaderManagerModule.setProgressBarMessage("");
            });

        } else if (response.status === 401) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak autoryzacji, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            }).then(() => {
                router.push("/login");
                lazyloaderManagerModule.setDisplayLazyLoader(false);
                lazyloaderManagerModule.setProgressBarMessage("");
            });
        } else if (response.status === 403) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak dostępu, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            })
                .then(() => {
                    router.push("/login");
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setProgressBarMessage("");
                });
        } else {
            var errorMessage = "";
            if (responseMessage) {
                errorMessage = responseMessage;
            }

            console.log("Wystąpił błąd!: " + errorMessage);
            return apiRequestsHelper.fireExceptionModal("Wystąpił błąd!", errorMessage, "error", response)
                .then(() => {
                        lazyloaderManagerModule.setDisplayLazyLoader(false);
                        lazyloaderManagerModule.setProgressBarMessage("");
                        console.log(response);
                    }
                );
        }

        return new Promise((resolve) => {
            resolve(response);
        })
    },
    handleResponseWithDialogsNoLazyLoaderFinish(response, showSuccessDialog) {
        console.log(response)
        var responseMessage = response.data.message;
        if (response.data && !responseMessage || responseMessage === "") {
            var dataParsed = JSON.parse(response.data?.text | "Brak danych");
            if (dataParsed) {
                responseMessage = dataParsed.message;
            }
        }
        const lazyloaderManagerModule = useLazyLoaderModule();
        if (response.status === 200) {

            if (showSuccessDialog) {
                return Swal.fire({
                    title: "Zrobione!",
                    text: responseMessage,
                    icon: "success",
                    customClass: {
                        container: "swal-highest"
                    },

                })
            }

        } else if (response.status === 203) {
            console.log("Staus 203:", response);
            return apiRequestsHelper.fireExceptionModal("Coś jest nie tak!", responseMessage, "warning", response)
                .then(() => {
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setProgressBarMessage("");
                    console.log("Returning 203 response: ", response);
                    return new Promise((resolve) => {
                        resolve(response);
                    });
                })


        } else if (response.status === 204) {
            console.log(response);
            return Swal.fire({
                title: "Błąd!",
                text: "Brak danych, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            }).then(() => {
                lazyloaderManagerModule.setDisplayLazyLoader(false);
                lazyloaderManagerModule.setProgressBarMessage("");
            });

        } else if (response.status === 401) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak autoryzacji, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            }).then(() => {
                router.push("/login");
                lazyloaderManagerModule.setDisplayLazyLoader(false);
                lazyloaderManagerModule.setProgressBarMessage("");
            });
        } else if (response.status === 403) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak dostępu, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            })
                .then(() => {
                    router.push("/login");
                    lazyloaderManagerModule.setDisplayLazyLoader(false);
                    lazyloaderManagerModule.setProgressBarMessage("");
                });
        } else {
            var errorMessage = "";
            if (responseMessage) {
                errorMessage = responseMessage;
            }

            console.log("Wystąpił błąd!: " + errorMessage);
            return apiRequestsHelper.fireExceptionModal("Wystąpił błąd!", errorMessage, "error", response)
                .then(() => {
                        lazyloaderManagerModule.setDisplayLazyLoader(false);
                        lazyloaderManagerModule.setProgressBarMessage("");
                        console.log(response);
                    }
                );
        }

        return new Promise((resolve) => {
            resolve(response);
        })
    },
    handleProgressResponseWithDialogs(response, showSuccessDialog) {
        // we can`t turn uff the lazy loader nor progressbar, because it is controlled by progress watching mechanism
        console.log(response)
        var responseMessage = response.data.message;
        if (response.data && !responseMessage || responseMessage === "") {
            var dataParsed = JSON.parse(response.data?.text | "Brak danych");
            if (dataParsed) {
                responseMessage = dataParsed.message;
            }
        }
        if (response.status === 200) {

            if (showSuccessDialog) {
                return Swal.fire({
                    title: "Zrobione!",
                    text: responseMessage,
                    icon: "success",
                    customClass: {
                        container: "swal-highest"
                    },

                })
            }

        } else if (response.status === 203) {
            console.log("Staus 203:", response);
            return apiRequestsHelper.fireExceptionModal("Coś jest nie tak!", responseMessage, "warning", response)
                .then(() => {
                    console.log("Returning 203 response: ", response);
                    return new Promise((resolve) => {
                        resolve(response);
                    });
                })


        } else if (response.status === 204) {
            console.log(response);
            return Swal.fire({
                title: "Błąd!",
                text: "Brak danych, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            })

        } else if (response.status === 401) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak autoryzacji, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            }).then(() => {
                router.push("/login");
            });
        } else if (response.status === 403) {
            return Swal.fire({
                title: "Błąd!",
                text: "Brak dostępu, zaloguj się ponownie",
                icon: "error",
                customClass: {
                    container: "swal-highest"
                },

            })
                .then(() => {
                    router.push("/login");
                });
        } else {
            var errorMessage = "";
            if (responseMessage) {
                errorMessage = responseMessage;
            }

            console.log("Wystąpił błąd!: " + errorMessage);
            return apiRequestsHelper.fireExceptionModal("Wystąpił błąd!", errorMessage, "error", response)
                .then(() => {
                        console.log(response);
                    }
                );
        }

        return new Promise((resolve) => {
            resolve(response);
        })
    },

    async handleResponseSilently(response) {
        const lazyloaderManagerModule = useLazyLoaderModule();
        console.log(response);
        lazyloaderManagerModule.setDisplayLazyLoader(false);
        lazyloaderManagerModule.setProgressBarMessage("");
        var responseMessage = response.data.message;
        if (response.data && !responseMessage || responseMessage === "") {
            var dataParsed = JSON.parse(await response.data?.text | "Brak danych");
            if (dataParsed) {
                responseMessage = dataParsed.message;
            }
        }

        if (response.status === 200) {
            // logging.log("Response status: 200: ");
            // logging.log(response);
        } else if (response.status === 203) {
            console.log("Response status: 203: ");
            console.log(response);
        } else if (response.status === 401) {
            console.log("Response status: 401: ");
            console.log(response);
            router.push("/login");
        } else if (response.status === 403) {
            console.log("Response status: 403: ");
            console.log(response);
            router.push("/login");
        } else {
            var errorMessage = "";
            if (responseMessage) {
                errorMessage = responseMessage;
            }
            console.log("Wystąpił błąd!: " + errorMessage);
        }

        return new Promise((resolve) => {
            resolve(response);
        })
    },

    async catchResponseError(error, methodName) {
        const lazyloaderManagerModule = useLazyLoaderModule();
        // if error contains 401 or 403 redirect to /login
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.log("catchResponseError: Redirecting to /login");
            router.push("/login");
            lazyloaderManagerModule.setDisplayLazyLoader(false);
            lazyloaderManagerModule.setProgressBarMessage("");
            return;
        }
        return apiRequestsHelper.fireExceptionModal("Wystąpił błąd metody HTTP: " + methodName + ":", error.toString(), "error").then(() => {
            lazyloaderManagerModule.setDisplayLazyLoader(false);
            lazyloaderManagerModule.setProgressBarMessage("");
            console.log("Wystąpił błąd metody HTTP: " + methodName + ": " + error);
        });
    },

    fireExceptionModal(title, message, icon, response) {
        return Swal.fire({
            title: title,
            icon: icon,
            showCancelButton: false,
            confirmButtonText: "OK",
            input: "textarea",
            inputPlaceholder: "Brak informacji",
            inputValue: message,
            customClass: {
                width: "850px!important",
                container: "swal-highest"
            },
            inputAttributes: {
                disabled: true
            }
        }).then(() => {

            return new Promise((resolve) => {
                resolve(response);
            })

        })
    }

}
